
































































































































































import {Vue, Component} from 'vue-property-decorator';
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import TextField from "@/components/inputs/TextField.vue";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import Decimal from "@/components/inputs/Decimal.vue";
import {store} from "@/store";
import Select61 from "@/components/inputs/Select61.vue";

class Harc {
  id!: number;
  harc_donemi_id!: number;
  harc_turu_id!: number;
  sabit_tutar_mi!: boolean;
  oran!: number;
  tutar!: number;
  min_tutar!: number;
}

class HarcTuru {
  id!: number;
  isim!: string;
  harc_tipi!: 'tahsil' | 'diger';
  kod!: string;
  ekle!: 'takip' | 'tahsilat';
}

@Component({
  computed: {
    store() {
      return store
    }
  },
  components: {Select61, Decimal, Id, EForm, TextField, DeleteButton},
})
export default class Harclar extends Vue {
  harcDialog: boolean = false;
  harcAction: string = this.$store.state.icwApiUrl + 'admin/harc';
  harcData = new Harc();
  harcTitle: string = "";
  harclarLoading: boolean = true;
  harclarHeaders = [
    {text: "Id", value: "id"},
    {text: "Dönem", value: "harc_donemi.baslangic_tarihi"},
    {text: "Tür", value: "harc_turu.isim"},
    {text: "Sabit Tutar Mı", value: "tutar_mi"},
    {text: "Oran", value: "oran"},
    {text: "Tutar", value: "tutar"},
    {text: "İşlemler", value: "actions"}
  ];
  harclar = [];
  harcSearch = "";

  harcTuruDialog: boolean = false;
  harcTuruAction: string = this.$store.state.icwApiUrl + 'admin/harc-turu';
  harcTuruData = new HarcTuru();
  harcTuruTitle: string = "";
  harcTurleriLoading: boolean = true;
  harcTurleriHeaders = [
    {text: "Id", value: "id"},
    {text: "İsim", value: "isim"},
    {text: "Tür", value: "harc_tipi"},
    {text: "Kod", value: "kod"},
    {text: "Ekle", value: "ekle"},
    {text: "İşlemler", value: "actions"}
  ];
  harcTurleri = [];
  harcTuruSearch = "";

  onSabitTutarMiChange(newValue: boolean) {
    if (newValue) {
      this.$delete(this.harcData, 'oran');
    } else {
      this.$delete(this.harcData, 'tutar');
    }
  }


  mounted() {
    this.loadHarclar();
    this.loadHarcTurleri();
  }

  async loadHarclar() {
    try {
      this.harclarLoading = true;
      this.harclar = (await this.$http.get(this.$store.state.icwApiUrl + 'admin/harclar')).data;
    } catch (e) {
      console.error('HATA ---: ',e);
    } finally {
      this.harclarLoading = false;
    }
  }

  async loadHarcTurleri() {
    try {
      this.harcTurleriLoading = true;
      this.harcTurleri = (await this.$http.get(this.$store.state.icwApiUrl + 'admin/harc-turleri')).data;
    } catch (e) {
      console.error('HATA ---: ',e);
    } finally {
      this.harcTurleriLoading = false;
    }
  }

  editHarc(item: Harc) {
    this.harcTitle = "Düzenle";
    this.harcData = item;
    this.harcAction = this.$store.state.icwApiUrl + 'admin/harc/' + item.id;
    this.harcDialog = true;
  }

  addHarc() {
    this.harcTitle = "Ekle";
    this.harcData = new Harc();
    this.harcAction = this.$store.state.icwApiUrl + 'admin/harc';
    this.harcDialog = true;
  }

  editHarcTuru(item: HarcTuru) {
    this.harcTuruTitle = "Düzenle";
    this.harcTuruData = item;
    this.harcTuruAction = this.$store.state.icwApiUrl + 'admin/harc-turu/' + item.id;
    this.harcTuruDialog = true;
  }

  addHarcTuru() {
    this.harcTuruTitle = "Ekle";
    this.harcTuruData = new HarcTuru();
    this.harcTuruAction = this.$store.state.icwApiUrl + 'admin/harc-turu';
    this.harcTuruDialog = true;
  }
  onHarcTuruSuccess() {
    this.loadHarcTurleri();
    this.harcTuruDialog = false;
  }
}
